import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField } from './form-field';
import { Textbox } from '../primitives/textbox';
import { FieldValidationMessage } from './form-control/form-control-validation-error';
import { TextMaskInput } from './text-mask-input';
import { FormControlLabel } from '../primitives/label';
import { FocusOnMount } from './focus-on-mount-hoc';
import { panelContentTransitionDuration } from './panel-content-transition';

export interface IAccountNumberInputProps {
	value: FormField<string>;
	formControlId: string;
	label: string;
	acceptanceTestTargetId: string;
	onFocus?: () => void;
	onBlur?: () => void;
	focusOnMount?: boolean;
	labelledBy?: string;
}

const mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

@observer
export class AccountNumberInput extends React.Component<IAccountNumberInputProps, {}> {
	render() {
		const { value: { value, updateValue, validationError, hasValidationError },
				formControlId, label, onFocus, onBlur, focusOnMount, labelledBy, acceptanceTestTargetId } = this.props;
		const additionalClassNames = hasValidationError ? 'form-control-invalid' : '';
		const maskedInput = (
			<TextMaskInput mask={mask}>
				<Textbox
					value={value}
					formControlId={formControlId}
					onChange={updateValue}
					acceptanceTestTargetId={acceptanceTestTargetId}
					numericKeyboard
					onFocus={onFocus}
					onBlur={onBlur}
					labelledBy={labelledBy}
					dataFieldInvalid={hasValidationError}
					additionalClassNames={additionalClassNames}
				/>
			</TextMaskInput>
		);

		return (
			<div className="form-control-container">
				<FormControlLabel formControlId={formControlId}>{label}</FormControlLabel>
					{focusOnMount ? (
						<FocusOnMount delay={panelContentTransitionDuration}>
							{maskedInput}
						</FocusOnMount>
					) : maskedInput}
				<FieldValidationMessage errorMessage={validationError} />
			</div>
		);
	}
}
